import MentoringInquiry from './MentoringInquiry.vue';

export default MentoringInquiry;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/inquiry/index.ts